import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const booknow = () => {
  let booking_panel = document.querySelector(".book-now__info-warpper");
  gsap.to(booking_panel, {
    scaleX: 1,
    scaleY: 1,
    duration: 1,
    ease: "power4.out",
  });
};

export default booknow;
